/* eslint-disable max-len */
import { useDispatch, useSelector } from 'react-redux';
import { reviewClaim } from '@api/review-claim';
import { setReviewInfo, setSelectedData } from '@store';
import { ClaimType } from '@constants';
import { logError } from '@log';

// 获取单选 package 的数据
const getDelayReportedItems = ({
  fulfilledItems,
  delayPackageId,
}) => {
  const packageItem = fulfilledItems.find((packageItem) => packageItem.fulfillmentId === delayPackageId);
  const { items } = packageItem;
  const itemList = [];
  items.forEach((item) => {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < item.quantity; i++) {
      itemList.push(item);
    }
  });
  return [{
    fulfillmentId: packageItem.fulfillmentId,
    fulfillmentName: packageItem.fulfillmentName,
    items: itemList,
    packageIndex: packageItem.packageIndex,
  }];
};
/**
 * 计算所选items的总金额
 * @param {Array} list  package list
 * @returns {Number} 计算后的总金额
 */
const getTotal = (list) => {
  let total = 0;
  list.forEach((p) => {
    p.items.forEach((item) => {
      const value = item.actualPrice?.match(/[\d.]+/g)[0];
      total += +value;
    });
  });
  return total;
};

const getCheckedReportedItems = ({
  fulfilledItems, selectedItems,
}) => {
  const result = [];

  fulfilledItems.forEach((packageItem, pIndex) => {
    const { items } = packageItem;
    const ids = selectedItems.filter((item) => {
      // eslint-disable-next-line no-unused-vars
      const [lineItemId, packageIndex, lineIndex] = item.split('_');
      return +packageIndex === pIndex;
    });
    if (!ids?.length) {
      return;
    }
    const itemList = [];
    items.forEach((item, index) => {
      ids.forEach((id) => {
        // eslint-disable-next-line no-unused-vars
        const [lineItemId, packageIndex, lineIndex] = id.split('_');
        if (lineItemId === item.lineItemId && index === +lineIndex) {
          itemList.push(item);
        }
      });
    });
    result.push({ ...packageItem, items: [...itemList] });
  });
  return result;
};

export const getFormatPackageList = ({
  delayPackageId,
  type,
  selectedItems, fulfilledItems,
}) => {
  const PackageListMap = {
    [ClaimType.Delay]: () => getDelayReportedItems({ fulfilledItems, delayPackageId }),
    [ClaimType.Damage]: () => getCheckedReportedItems({ fulfilledItems, selectedItems }),
    [ClaimType.Loss]: () => getCheckedReportedItems({ fulfilledItems, selectedItems }),
    [ClaimType.RA]: () => getCheckedReportedItems({ fulfilledItems, selectedItems }),
  };

  return PackageListMap[type]();
};

// 获取请求中的 itemList 数组
const getItemList = (selectedPackageList, type) => {
  const itemList = [];
  selectedPackageList.forEach((packageItem) => {
    const { items, fulfillmentId } = packageItem;
    if (type === ClaimType.Delay) {
      itemList.push({
        fulfillmentId,
      });
    } else {
      items.forEach((item) => {
        // const { lineItemId } = item;
        // const lastItemIndex = itemList.findIndex((v) => lineItemId === v.lineItemId);
        // if (lastItemIndex === -1) {
        itemList.push({
          comment: item.comment,
          lineItemId: item.lineItemId,
          reason: item.reason,
          fulfillmentId,
          attachments: item?.attachments?.map((file) => ({ fileLink: file.path, originalFileName: file.originalFileName })),

        });
        // } else {
        //   const lastItem = itemList[lastItemIndex];
        //   // eslint-disable-next-line no-plusplus
        //   lastItem.quantity++;
        // }
      });
    }
  });
  return itemList;
};

export const useReviewData = () => {
  const {
    delayPackageId,
    type,
    selectedItems, policyId, fulfilledItems, paymentMethod, files, comments,
  } = useSelector((state) => state.claim);

  const dispatch = useDispatch();

  const getReviewData = async ({ payment = {}, ...paymentInfo } = {}) => {
    const selectedPackageList = getFormatPackageList({
      delayPackageId,
      type,
      selectedItems,
      fulfilledItems,
    });
    // const totalMoneyValue = getTotal(selectedPackageList);

    const body = {
      issueType: type,
      attachments: files.map((file) => ({ fileLink: file.path, originalFileName: file.name })),
      items: getItemList(selectedPackageList, type),
      policyId,
      paymentMethod: payment.value || paymentMethod.value, // paymentMethod
      ...paymentInfo,
      comment: comments,
    };
    try {
      const data = await reviewClaim(body);
      if (!data) {
        return false;
      }
      dispatch(setSelectedData({ body, selectedPackageList }));
      dispatch(setReviewInfo(data));
      return true;
    } catch (error) {
      logError(error);
      return false;
    }
  };
  const getAllTotalAmount = () => {
    const selectedPackageList = getFormatPackageList({
      delayPackageId,
      type,
      selectedItems,
      fulfilledItems,
    });
    const totalMoneyValue = getTotal(selectedPackageList);
    return totalMoneyValue;
  };
  return {
    getReviewData, getAllTotalAmount,
  };
};
